import React from 'react';
import { GoogleMap, Circle, useJsApiLoader } from '@react-google-maps/api';
import { MAPS_KEY } from 'src/config';

interface MapComponentProps {
  latitude: number;
  longitude: number;
  width?: string;
  height?: string;
}

export const MapComponentObscure: React.FC<MapComponentProps> = ({ 
  latitude, 
  longitude, 
  width = '100%', 
  height = '400px' 
}) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: MAPS_KEY,
  });

  const center = {
    lat: latitude,
    lng: longitude,
  };

  // Circle options for 50-mile radius
  const circleOptions = {
    strokeColor: '#FF0000',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#FF0000',
    fillOpacity: 0.15,
    clickable: false,
    // Convert 50 miles to meters (1 mile = 1609.34 meters)
    radius: 50 * 1609.34
  };

  const onLoad = React.useCallback((map) => {
    // Calculate zoom level to show the entire circle
    // A lower zoom level (e.g., 8) will show more area
    map.setCenter(center);
    map.setZoom(8);
  }, [center]);

  const onUnmount = React.useCallback(() => {}, []);

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={{ width, height, border: '0px' }}
      center={center}
      zoom={8} // Lower zoom level to show the circle
      onLoad={onLoad}
      onUnmount={onUnmount}
      options={{
        // Optional: Customize map appearance
        disableDefaultUI: false,
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: true,
      }}
    >
      <Circle
        center={center}
        options={circleOptions}
      />
    </GoogleMap>
  ) : null;
};

export default React.memo(MapComponentObscure);